import React from 'react';

class OrderDetailContainer extends React.Component {

    render() {
        return  <div></div>
    }
}

export default OrderDetailContainer;